import { render } from "./HighlightsGames.vue?vue&type=template&id=7ecd8b2e&scoped=true"
import script from "./HighlightsGames.vue?vue&type=script&lang=js"
export * from "./HighlightsGames.vue?vue&type=script&lang=js"

import "./HighlightsGames.vue?vue&type=style&index=0&id=7ecd8b2e&scoped=true&lang=css"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecd8b2e"]])

export default __exports__